export const baseLocales = ['en', 'de', 'es', 'fr', 'it', 'pt', 'ru', 'ja', 'ko', 'zh']

export const essentialLocales = [
  'ar',
  'bg',
  'ceb',
  'cs',
  'da',
  'el',
  'et',
  'fi',
  'fj',
  'gn',
  'hr',
  'ht',
  'hu',
  'hy',
  'id',
  'ka',
  'km',
  'lt',
  'lv',
  'mg',
  'mn',
  'ms',
  'nl',
  'no',
  'pl',
  'ro',
  'sk',
  'sm',
  'sq',
  'sv',
  'sw',
  'th',
  'tl',
  'to',
  'tr',
  'uk',
  'vi',
]

export const extendedLocales = ['is', 'mk', 'sl', 'sr']

export const allLocales = baseLocales.concat(essentialLocales, extendedLocales)

// native script and ordering should match Church lang picker
export const langText = {
  core: [
    { code: 'de', text: 'Deutsch' },
    { code: 'en', text: 'English' },
    { code: 'es', text: 'Español' },
    { code: 'fr', text: 'Français' },
    { code: 'it', text: 'Italiano' },
    { code: 'pt', text: 'Português' },
    { code: 'ru', text: 'Русский' },
    { code: 'ja', text: '日本語' },
    { code: 'ko', text: '한국어' },
    { code: 'zh', text: '繁體中文' },
  ],
  additional: [
    { code: 'id', text: 'Bahasa Indonesia' },
    { code: 'ms', text: 'Bahasa Melayu' },
    { code: 'ceb', text: 'Cebuano' },
    { code: 'cs', text: 'Česky' },
    { code: 'da', text: 'Dansk' },
    { code: 'et', text: 'Eesti' },
    { code: 'to', text: 'Faka-tonga' },
    { code: 'sm', text: 'Gagana Samoa' },
    { code: 'gn', text: `Guaraní (Avañe'ẽ)` },
    { code: 'hr', text: 'Hrvatski' },
    { code: 'is', text: 'Íslenska' },
    { code: 'sw', text: 'Kiswahili' },
    { code: 'ht', text: 'Kreyòl Ayisyen' },
    { code: 'lv', text: 'Latviešu' },
    { code: 'lt', text: 'Lietuvių' },
    { code: 'hu', text: 'Magyar' },
    { code: 'mg', text: 'Malagasy' },
    { code: 'nl', text: 'Nederlands' },
    { code: 'no', text: 'Norsk' },
    { code: 'pl', text: 'Polski' },
    { code: 'ro', text: 'Română' },
    { code: 'sq', text: 'Shqip' },
    { code: 'sk', text: 'Slovenčina' },
    { code: 'sl', text: 'Slovenščina' },
    { code: 'fi', text: 'Suomi' },
    { code: 'sv', text: 'Svenska' },
    { code: 'tl', text: 'Tagalog' },
    { code: 'vi', text: 'Tiếng Việt' },
    { code: 'tr', text: 'Türkçe' },
    { code: 'fj', text: 'Vosa vakaviti' },
    { code: 'el', text: 'Ελληνικά' },
    { code: 'bg', text: 'Български' },
    { code: 'mk', text: 'македонски' },
    { code: 'mn', text: 'Монгол' },
    { code: 'sr', text: 'српски' },
    { code: 'uk', text: 'Українська' },
    { code: 'ka', text: 'ქართული' },
    { code: 'hy', text: 'Հայերեն' },
    { code: 'ur', text: 'اردو' },
    { code: 'ar', text: 'العربية' },
    { code: 'fa', text: 'فارسی' },
    { code: 'th', text: 'ภาษาไทย' },
    { code: 'km', text: 'ភាសាខ្មែរ' },
    { code: 'zh-hans', text: '简体中文' },
  ],
}

// Simplified Chinese (zh-hans) has not been approved yet, so only available via experiment additionalLanguagesSimpChineseEx

export const languageFlags = {
  essential: [
    { experiment: 'additionalLanguagesSimpChineseEx', locale: 'zh-hans' },
    { flag: 'shared_addLangSimplifiedChinese', locale: 'zh-hans' },
    { flag: 'shared_addLangFarsi', locale: 'fa' },
    { flag: 'shared_addLangUrdu', locale: 'ur' },
  ],
  extended: [],
  supported: [],
}

const experimentalLocales = [...languageFlags.essential, ...languageFlags.extended, ...languageFlags.supported].map(
  (entry) => entry.locale
)

export default allLocales.concat(experimentalLocales, 'eo')
